import React, { useEffect } from 'react';
import { Modal } from '@gerdau/hefesto';
import { sendTagging } from '../../../../../../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../../../../../../utils/Tagging';
import { useDispatch } from 'react-redux';

interface CancelUploadFilesProps {
  onCancelClick: () => void;
  onContinueClick: () => void;
}

const CancelUploadFiles: React.FC<CancelUploadFilesProps> = ({
  onCancelClick,
  onContinueClick
}) => {
  const dispatch = useDispatch();

  const { screenName = '' } = getTaggingInformationScreen(
    'modal-cancelar-edicao-projeto'
  );

  useEffect(() => {
    dispatch(
      sendTagging({
        page: window.location.pathname,
        screenName,
        event: 'page_view'
      })
    );
  }, []);

  return (
    <Modal
      title="Cancelar a edição do projeto?"
      buttons={{
        left: {
          children: 'Continuar',
          name: 'continue',
          onClick: onContinueClick,
          type: 'button'
        },
        right: {
          children: 'Cancelar',
          name: 'cancel-edit-confirm',
          onClick: onCancelClick,
          type: 'button',
          variant: 'danger'
        }
      }}
      modalSize="sm"
      onClose={onCancelClick}
    >
      <span>Deseja cancelar a edição do projeto?</span>
    </Modal>
  );
};

export default CancelUploadFiles;
